<template>
    <div class="tc-case-menu-navigation-item"
         :class="{'tc-case-navigation-active': isActive}"
         @click="$emit('select')">
        <div class="tc-navigation-item-icon-container">
            <slot name="icon"></slot>
        </div>
        <div class="tc-navigation-item-text">
            {{label}}
        </div>
    </div>
</template>

<script>
export default {
    name: 'CaseMenuNavigationItem',
    props: [
        'label',
        'isActive',
    ],
    emits: [
        'select',
    ],
};
</script>

<style scoped lang="scss">
.tc-case-menu-navigation-item {
    width: 100%;
    height: max-content;
    display: flex;
    box-sizing: border-box;
    flex-direction: column;
    gap: 10px;
    justify-content: center;
    align-items: center;
    color: #333333;
    font-size: 14px;
    cursor: pointer;
    user-select: none;
    transition: 0.3s ease all;
}

.tc-case-menu-navigation-item:hover {
    color: #00458D;
}

.tc-case-menu-navigation-item:active {
    color: #0170E3;
}

.tc-case-navigation-active {
    color: #00458D;
}

.tc-navigation-item-icon-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 50px;
    width: 70px;
    overflow: hidden;
}

.tc-navigation-item-text {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;

}
</style>
